import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import InfoText from './InfoText';


export default function InfoPopup(props: any) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    // const handleClickOpen = () => {
    //     props.setOpen(true);
    //   };

    const handleClose = () => {
        props.setInfoPopup({ open: false, title: "", text: "" });
    };

    return (
        <div>
            <Dialog
                fullScreen={fullScreen}
                open={props.infoPopup.open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{ zIndex: 1000000 }}
            >
                {(props.infoPopup.id !== "NDVI" || props.infoPopup.id !== "NDWI") &&

                    <DialogTitle id="responsive-dialog-title">
                        {props.infoPopup.title}
                    </DialogTitle >
                }

                <DialogContent>
                    <DialogContentText>
                        <InfoText {...props} />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ mr: "24px", color: "black" }} onClick={handleClose} autoFocus >
                        Zurück
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}